import type { ComponentProps } from 'react';

import { forwardRef } from 'react';
import { mergeClasses } from 'minimal-shared/utils';

import { navSectionClasses } from './nav-section-classes';

export const Nav = forwardRef<HTMLElement, ComponentProps<'nav'>>(
  ({ className, ...props }, ref) => <nav ref={ref} className={className} {...props} />
);

Nav.displayName = 'Nav';

type NavLiProps = ComponentProps<'li'> & {
  disabled?: boolean;
};

export const NavLi = forwardRef<HTMLLIElement, NavLiProps>(
  ({ disabled, className, ...props }, ref) => (
    <li
      ref={ref}
      className={mergeClasses([
        navSectionClasses.li,
        'inline-block',
        disabled ? 'cursor-not-allowed' : undefined,
        className,
      ])}
      {...props}
    />
  )
);

NavLi.displayName = 'NavLi';

type NavUlProps = ComponentProps<'ul'>;

export const NavUl = forwardRef<HTMLUListElement, NavUlProps>(({ className, ...props }, ref) => (
  <ul
    ref={ref}
    className={mergeClasses([navSectionClasses.ul, 'flex flex-col', className])}
    {...props}
  />
));

NavUl.displayName = 'NavUl';
